import React, { useEffect } from 'react';
import { change, Field, formValueSelector } from "redux-form";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';

// Components
import CommonFormComponent from "../../CommonField/CommonFormComponent";

// Helper
import messages from "../../../locale/jsonMessages";

const TargetRenterSelect = () => {

    const dispatch = useDispatch();
    const selector = formValueSelector('reservationMessageForm');
    const selectedTarget = useSelector(state =>
        selector(state, 'targetRenters')
    );

    const { formatMessage } = useIntl();

    const options = [
        { label: formatMessage(messages.targetRentersAll), value: 'All' },
        { label: formatMessage(messages.targetRentersTouristsSightseers), value: 'Tourists & Sightseers' },
        { label: formatMessage(messages.targetRentersBusinessTravelers), value: 'Business Travelers' },
        { label: formatMessage(messages.targetRentersCityDwellers), value: 'City Dwellers Without Cars' },
        { label: formatMessage(messages.targetRentersStudentsYoungAdults), value: 'Students & Young Adults' },
        { label: formatMessage(messages.targetRentersEmergencyRenters), value: 'Emergency Renters' },
        { label: formatMessage(messages.targetRentersOthers), value: 'Others' }
    ];

    useEffect(() => {
        if (!selectedTarget && options.length > 0) {
            dispatch(change('reservationMessageForm', 'targetRenters', options[0].value));
        }
    }, [options, selectedTarget]);

    return (
        <Field
            name="targetRenters"
            component={CommonFormComponent}
            labelText={formatMessage(messages.chooseTargetRentersLabel)}
            inputClass='commonSelectField'
        >
            {options.map((item, index) => (
                <option key={index} value={item.value}>
                    {item.label}
                </option>
            ))}
        </Field>

    );
};

export default TargetRenterSelect;
